export class SousCategorie {
    id: number;
    name: string;
    website: string;
    category: string;
    image_url?: string;        // may be deprecated, keep for compatibility
    listimages: string[];      // array of image URLs (or S3 keys)
    description: string;
    prix: string;
    displayOrder?: number;
}